var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { ToggleButton, useModal, H3 } from "@animech/ui";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import * as Styled from "./topbar.style";
import { CalculateButton } from "./calculate-button";
import { useAppDispatch, useAppSelector, selectors, actions } from "store";
import { MessagesPopover, MessageLevel, } from "ui/components/elements/messages-popover";
import { useSystemWarningMessages, useSystemErrorMessages, useSystemInfoMessages, } from "hooks/messages";
import { UndoRedo } from "ui/components/elements/undo-redo";
import { IconButton } from "ui/components/elements/icons/icon-button";
import { useNewsFlashModal } from "hooks/newsflash";
import { CameraViewId } from "3d/types";
import { GoogleAnalyticsElement } from "ui/components/elements/ga-element/ga-element";
import { googleAnalyticsEvents } from "utility/constants";
import { SaveSystemStateModal } from "ui/components/modals/ovm-backend/save-system-modal/save-system-modal";
import { TimedNotification } from "ui/components/elements/timed-notification";
import { TopBarMenu } from "ui/components/panels/topbar/topbar-menu";
import { LanguagePicker } from "ui/components/panels/topbar/language-picker";
export var TopbarPanel = function () {
    var _a = __read(useState(false), 2), menuOpened = _a[0], setMenuOpened = _a[1];
    var _b = __read(useState(null), 2), openPopover = _b[0], setOpenPopover = _b[1];
    var toolbarRef = useRef(null);
    var openModal = useModal();
    var t = useTranslation().t;
    var activeSystem = useAppSelector(selectors.selectUserActiveSystem);
    var _c = __read(useState(false), 2), showSaveSuccessNotification = _c[0], setShowSaveSuccessNotification = _c[1];
    var onSave = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openModal(_jsx(SaveSystemStateModal, {})).done()];
                case 1:
                    success = _a.sent();
                    if (success) {
                        setShowSaveSuccessNotification(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [openModal]);
    var dispatch = useAppDispatch();
    var _d = useSystemWarningMessages(), warningMessages = _d.messages, isLoadingWarningMessages = _d.isLoading;
    var errorMessages = useSystemErrorMessages().messages;
    var infoMessages = useSystemInfoMessages().messages;
    useEffect(function () {
        if (!menuOpened)
            return;
        var handleClickOutside = function (e) {
            if (toolbarRef.current &&
                !toolbarRef.current.contains(e.target)) {
                setMenuOpened(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () { return document.removeEventListener("mousedown", handleClickOutside); };
    }, [menuOpened]);
    useNewsFlashModal();
    var cameraViewId = useAppSelector(selectors.selectCameraViewId);
    var popoverToggleHandlers = useMemo(function () {
        var _a;
        return (_a = {},
            _a[MessageLevel.INFO] = function (open) {
                return setOpenPopover(open ? MessageLevel.INFO : null);
            },
            _a[MessageLevel.WARNING] = function (open) {
                return setOpenPopover(open ? MessageLevel.WARNING : null);
            },
            _a[MessageLevel.ERROR] = function (open) {
                return setOpenPopover(open ? MessageLevel.ERROR : null);
            },
            _a);
    }, []);
    var toggleCameraView = useCallback(function () {
        return dispatch(actions.setCameraView(cameraViewId === CameraViewId.INITIAL_3D_VIEW
            ? CameraViewId.EDIT_VIEW
            : CameraViewId.INITIAL_3D_VIEW));
    }, [cameraViewId, dispatch]);
    return (_jsxs(Styled.TopbarPanel, { children: [_jsxs(Styled.Toolbar, { ref: toolbarRef, children: [_jsxs(Styled.WidgetRow, { children: [_jsx(ToggleButton, { color: "inverted", onValueChange: function () { return setMenuOpened(!menuOpened); }, label: _jsx(Styled.Icon, { src: "img/app/settings.svg" }), value: menuOpened }), _jsx(UndoRedo, {}), _jsxs(Styled.ToggleGroup, { title: t("topbar.toggle_camera_view"), children: [_jsx(ToggleButton, { color: "inverted", onValueChange: toggleCameraView, label: _jsx(Styled.Icon, { src: "img/app/2D.svg" }), value: cameraViewId !== CameraViewId.INITIAL_3D_VIEW, disabled: cameraViewId !== CameraViewId.INITIAL_3D_VIEW }), _jsx(ToggleButton, { color: "inverted", onValueChange: toggleCameraView, label: _jsx(Styled.Icon, { src: "img/app/3D.svg" }), value: cameraViewId === CameraViewId.INITIAL_3D_VIEW, disabled: cameraViewId === CameraViewId.INITIAL_3D_VIEW })] }), _jsx(GoogleAnalyticsElement, { event: googleAnalyticsEvents.click.save, children: _jsx(IconButton, { color: "inverted", onClick: onSave, children: _jsx(Styled.Icon, { src: "img/app/save.svg" }) }) }), _jsx(LanguagePicker, {})] }), menuOpened && _jsx(TopBarMenu, {})] }), _jsx(Styled.SystemName, { children: _jsx(H3, { children: (activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.name) || "" }) }), _jsxs(Styled.RightAligned, { children: [_jsx(MessagesPopover, { messages: infoMessages, level: MessageLevel.INFO, controlledOpen: openPopover === MessageLevel.INFO, onControlledToggle: popoverToggleHandlers[MessageLevel.INFO] }), _jsx(MessagesPopover, { messages: warningMessages, isLoading: isLoadingWarningMessages, level: MessageLevel.WARNING, controlledOpen: openPopover === MessageLevel.WARNING, onControlledToggle: popoverToggleHandlers[MessageLevel.WARNING] }), _jsx(MessagesPopover, { messages: errorMessages, level: MessageLevel.ERROR, openOnChange: true, controlledOpen: openPopover === MessageLevel.ERROR, onControlledToggle: popoverToggleHandlers[MessageLevel.ERROR] }), _jsx(CalculateButton, {})] }), showSaveSuccessNotification && (_jsx(TimedNotification, { text: t("save_system_modal.save_success"), timeout: 5000, color: "success", onClose: function () { return setShowSaveSuccessNotification(false); } }))] }));
};
